/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DoctorReassignTable.vue?vue&type=template&id=465ef21a&scoped=true"
import script from "./DoctorReassignTable.vue?vue&type=script&lang=js"
export * from "./DoctorReassignTable.vue?vue&type=script&lang=js"
import style0 from "./DoctorReassignTable.vue?vue&type=style&index=0&id=465ef21a&lang=scss&scoped=true"
import style1 from "./DoctorReassignTable.vue?vue&type=style&index=1&id=465ef21a&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ef21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('465ef21a')) {
      api.createRecord('465ef21a', component.options)
    } else {
      api.reload('465ef21a', component.options)
    }
    module.hot.accept("./DoctorReassignTable.vue?vue&type=template&id=465ef21a&scoped=true", function () {
      api.rerender('465ef21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/DoctorReassignTable.vue"
export default component.exports